module.exports = __webpack_public_path__ + "static/media/app_icon.8aea4598.png";